module.exports = __webpack_public_path__ + "static/media/img_client_fitt.19adb9c7.png";